//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

export const getIsMediaLibraryPageEnabled = createHasFeatureSelector(
  FeatureNames.MediaLibraryPage,
);

export const getIsTributarySelfServeEnabled = createHasFeatureSelector(
  FeatureNames.TributarySelfServe,
);

// TODO: PD-264130 - Remove content_library_labels_improvements feature flag
export const getIsContentLibraryLabelsImprovementsEnabled =
  createHasFeatureSelector(FeatureNames.ContentLibraryLabelsImprovements);
